import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_LIST_PASSPORTS,
    RESPOND_ADD_PASSPORT,
    RESPOND_UPDATE_PASSPORT,
    RESPOND_REMOVE_PASSPORT,
    NOTIFY_PASSPORT_UPDATE,
    RESPOND_LIST_DASHBOARDS,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/splunkMsgDefinitions";
import {
    SplunkPassport,
    SplunkPassportHeader,
    SplunkPassportID,
    SplunkDashboard,
} from "userful-chronos-app-common-js/dist/models/integration/splunk";
import integrationStore from "../integrationStore";
import { splunkActions } from "../splunkSlice";
import { registerErrorMsgHandlerByMsgDefinition } from "userful-chronos-app-common-js/dist/message/messageRegistery";

registerMsgHandler(RESPOND_LIST_PASSPORTS, (payload) => {
    const data = JSON.parse(payload) as SplunkPassport[];
    integrationStore.dispatch(splunkActions.setPassports(data));
});

registerMsgHandler(RESPOND_ADD_PASSPORT, (payload) => {
    const data = JSON.parse(payload) as SplunkPassportHeader;
    integrationStore.dispatch(splunkActions.changeLoadState("RENDER"));
    integrationStore.dispatch(splunkActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_ADD_PASSPORT, (data) => {
    integrationStore.dispatch(splunkActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_PASSPORT, (payload) => {
    const data = JSON.parse(payload) as SplunkPassportHeader;
    integrationStore.dispatch(splunkActions.changeLoadState("RENDER"));
    integrationStore.dispatch(splunkActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_PASSPORT, (data) => {
    integrationStore.dispatch(splunkActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_REMOVE_PASSPORT, (payload) => {
    const data = JSON.parse(payload) as SplunkPassportID;
    integrationStore.dispatch(splunkActions.removePassport(data));
});

registerMsgHandler(NOTIFY_PASSPORT_UPDATE, (payload) => {
    const data = JSON.parse(payload) as SplunkPassport;
    integrationStore.dispatch(splunkActions.addOrUpdatePassport(data));
});

registerMsgHandler(RESPOND_LIST_DASHBOARDS, (payload) => {
    const data = JSON.parse(payload) as SplunkDashboard[];
    integrationStore.dispatch(splunkActions.setDashboards(data));
});
